<i18n>
{
  "en": {
    "selectItem": "Select item"
  },
  "es": {
    "selectItem": "Seleccionar elemento"
  }
}
</i18n>
<template>
  <!--  Restaurant list -->
  <v-menu transition="slide-y-transition" bottom v-if="!shouldUseButtons" :disabled="disabled" max-height="450">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="secondary" :class="btnClasses" v-bind="attrs" v-on="on" v-if="!!itemSelectedReal">
        <v-avatar size="30" class="mr-2"
                  v-if="!!itemSelectedReal && !!itemSelectedReal[elementImage] && $vuetify.breakpoint.mdAndUp">
          <img :src="itemSelectedReal[elementImage]" :alt="itemSelectedReal[elementLabel]">
        </v-avatar>
        <span v-if="$vuetify.breakpoint.mdAndUp" class="primary--text">{{ itemSelectedReal[elementLabel] }}</span>
        <span class="primary--text d-inline-block text-truncate" :style="dropdownStyle"
              v-if="$vuetify.breakpoint.smAndDown">{{ itemSelectedReal[elementLabel] }}</span>
      </v-btn>
    </template>
    <v-list>
      <v-list-item v-for="(element,index) in list" :key="element[elementKey]"
                   @click="onClick(element)"
                   :disabled="isDisabled(index)">
        <v-avatar size="36" class="mr-3" v-if="!!element[elementImage]">
          <img :src="element[elementImage]" :alt="element[elementLabel]">
        </v-avatar>
        <v-list-item-title>{{ element[elementLabel] }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
  <v-btn-toggle v-else v-model="selectedElementBtn" mandatory class="d-flex justify-center" style="width: 100%">
    <div v-for="(e, index) in buttonsThreshold" :key="index" class="mx-1">
      <v-btn :class="getBtnClasses(index)" v-if="list[index]" :disabled="isDisabled(index)" class="pa-0">
        <v-avatar size="30" class="mr-2" v-if="list[index][elementImage] && $vuetify.breakpoint.mdAndUp">
          <img :src="list[index][elementImage]" :alt="list[index][elementLabel]">
        </v-avatar>
        <div v-if="$vuetify.breakpoint.mdAndUp" class="primary--text px-3">{{ list[index][elementLabel] }}</div>
        <div class="primary--text text-truncate px-3 button-text-width"
              v-if="$vuetify.breakpoint.smAndDown">{{ list[index][elementLabel] }}</div>
      </v-btn>
    </div>
  </v-btn-toggle>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class DynameatDropdown extends Vue {
  @Prop({ default: null, required: true }) itemSelected;

  @Prop({ String, default: 'key' }) elementKey;

  @Prop({ String, default: null }) selectDefaultLabel;

  @Prop({ String, default: 'label' }) elementLabel;

  @Prop({ default: null, required: true }) list;

  @Prop({ String, default: 'image' }) elementImage;

  @Prop({ Boolean, default: false }) disabled;

  @Prop({ String, default: 'secondary black--text' }) btnClasses;

  @Prop({ Boolean, default: false }) useButtons;

  @Prop({ Number, default: 2 }) buttonsThreshold;

  @Prop({ String, default: 'primary-button-dropdown' }) buttonSelectedClass;

  @Prop({ default: null }) disabledList;

  @Prop({ String, default: 'max-width: 220px;' }) dropdownStyle;

  selectedElementBtn = -1;

  get itemSelectedReal() {
    let { itemSelected } = this;
    if (!itemSelected) {
      if (this.list.length > 0) {
        itemSelected = this.list[0];
      } else {
        itemSelected = {
          elementKey: -1,
          elementLabel: this.selectDefaultLabel || this.$t('selectItem'),
          elementImage: null
        };
      }
    }
    return itemSelected;
  }

  get shouldUseButtons() {
    return this.useButtons && this.list.length <= this.buttonsThreshold;
  }

  @Watch('selectedElementBtn')
  onSelectedElementBtnChanged(val) {
    this.$emit('on-select', this.list[val]);
  }

  onClick(element) {
    this.$emit('on-select', element);
  }

  getBtnClasses(index) {
    if (this.selectedElementBtn !== index) {
      return this.btnClasses;
    }
    return this.buttonSelectedClass;
  }

  isDisabled(index) {
    if (this.disabled) {
      return true;
    }
    if (this.disabledList === null) {
      return false;
    }

    return this.disabledList.includes(this.list[index]);
  }
}
</script>

<style>
.primary-button-dropdown {
  background-color: var(--v-accent-base) !important;
}
</style>
<style scoped>
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 30px;
}

.button-text-width {
   width: 160px;
}

</style>
